import * as React from "react"
import { Link, graphql } from "gatsby"
import Bio from "../components/bio"
import Layout from "../components/layout"
import Seo from "../components/SEO/seo"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useEffect } from "react"
import kebabCase from "lodash/kebabCase"



const BlogPostTemplate = ({ data, location }) => {
  useEffect(() => {
    window.scrollTo(0,0)
  }, [data])
  const post = data.markdownRemark
  const siteTitle = data.site.siteMetadata?.title || `Title`
  const { previous, next } = data
  const image = getImage(post.frontmatter.featuredImage)
  const tags = post.frontmatter.tags
  return (
    <Layout location={location} title={siteTitle}>
      <div className="container bg-white">
        <Seo
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
        />
        <article
          className="blog-post"
          itemScope
          itemType="http://schema.org/Article"
        >
          <header>

            <div className="card mx-auto mt-5 mb-5 bg-dark text-white">
              <div className="container p-0">
                <GatsbyImage className="" image={image} alt={post.frontmatter.featuredImage.name} />
              </div>

                  <div className="card-img-overlay-fliped ">
                    <div className="row h-100 align-items-end">
                      <div className="col ">
                    <h1 className="text-white col-md-9">{post.frontmatter.title}</h1>

                        <small className="card-text font-weight-bold">
                          <ul className="list-inline">
                            {tags.map(tag => (
                              <li className="list-inline-item" key={tag}>
                                <Link to={`/tags/${kebabCase(tag)}/`}>
                                  <span className="badge rounded-pill bg-light text-dark"> {tag}</span>

                                </Link>
                              </li>
                            ))}
                          </ul>
                        </small>
                        <small className="card-text font-weight-bold">{post.frontmatter.date}</small>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div className="container">
            <section
              dangerouslySetInnerHTML={{ __html: post.html }}
              itemProp="articleBody"
            />
          </div>

          <hr />
          <footer>
            <div className="container">
              <Bio />
            </div>

          </footer>
        </article>
        <nav className="blog-post-nav">
          <ul
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: `space-between`,
              listStyle: `none`,
              padding: 0,
            }}
          >
            <li>
              {previous && (
                <Link to={previous.fields.slug} rel="prev">
                  <div className="d-flex p-3 align-items-center ">
                    <div className="flex-shrink-0">
                      {/*<GatsbyImage className="img-small"  image={prevImage} alt={previous.frontmatter.featuredImage.name} />*/}
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <small>Previous</small>
                      <h6 className="mb-1"> {previous.frontmatter.title}</h6>
                    </div>
                  </div>

                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={next.fields.slug} rel="next">
                  <div className="d-flex p-3 align-items-center">
                    <div className="flex-shrink-0">
                      {/*<GatsbyImage className="img-small"  image={nextImage} alt={next.frontmatter.featuredImage.name} />*/}
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <small>Next Artile</small>
                      <h6 className="mb-1"> {next.frontmatter.title}</h6>
                    </div>
                  </div>
                </Link>
              )}
            </li>
          </ul>
        </nav>

      </div>

    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        category
        tags
        featuredImage {
          childImageSharp {
          gatsbyImageData(
             formats: [AUTO, WEBP, AVIF]
              placeholder: DOMINANT_COLOR
              breakpoints: [750, 1080, 1366, 1920]
          )
        }
        name
        }
      }
    }
    previous: markdownRemark(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
        featuredImage {
          childImageSharp {
          gatsbyImageData(
             formats: [AUTO, WEBP, AVIF]
              placeholder: DOMINANT_COLOR
              layout: FIXED
              width: 200
              height: 200
          )
        }
        name
        }
      }
    }
    next: markdownRemark(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
         featuredImage {
          childImageSharp {
          gatsbyImageData(
             formats: [AUTO, WEBP, AVIF]
              placeholder: DOMINANT_COLOR
              layout: FIXED
              width: 200
              height: 200
          )
        }
        name
        }
      }
    }
  }
`
